<a (click)="addAudit()" *ngIf="(isAdmin() | async)" class="btn btn-default btn-sm btn-demo" title="Dodaje link do raportu na stronę głowną">Add to LP</a>
